import React, { useState, useEffect } from "react";
import Carousel from "react-bootstrap/Carousel";
import client from "../contentfulClient";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
let process = {
  env: {}
};
const FAQItem = _ref => {
  let {
    faq,
    index,
    toggleFAQ,
    activeIndex
  } = _ref;
  const isActive = activeIndex === index;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    onClick: () => toggleFAQ(index),
    style: {
      cursor: "pointer",
      fontSize: "16px",
      fontWeight: "600",
      margin: "24px 0px 0px",
      display: "flex",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "275px"
    }
  }, faq.question), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("img", {
    style: {
      height: "16px"
    },
    src: isActive ? "https://d3hc1c528irei0.cloudfront.net/ui/VectorUp.png" : "https://d3hc1c528irei0.cloudfront.net/ui/VectorDown.png",
    alt: ""
  }))), isActive && /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "8px",
      opacity: "0.8",
      fontSize: "14px",
      fontWeight: "400"
    }
  }, /*#__PURE__*/React.createElement(ReactMarkdown, {
    rehypePlugins: [rehypeRaw],
    remarkPlugins: [remarkGfm]
  }, faq.answer)), /*#__PURE__*/React.createElement("div", {
    style: {
      height: "1px",
      backgroundColor: "white",
      marginTop: "24px"
    }
  }));
};
const FAQList = _ref2 => {
  var _posts$fields, _posts$fields2, _posts$fields3;
  let {
    faqs,
    posts,
    navigate
  } = _ref2;
  const [activeIndex, setActiveIndex] = useState(null);
  const toggleFAQ = index => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "32px 24px 40px",
      color: "#fff",
      paddingBottom: "117px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "24px",
      fontWeight: "400",
      marginBottom: "24px"
    }
  }, posts === null || posts === void 0 || (_posts$fields = posts.fields) === null || _posts$fields === void 0 ? void 0 : _posts$fields.faqTitle), faqs.map((faq, index) => /*#__PURE__*/React.createElement(FAQItem, {
    key: index,
    faq: faq,
    index: index,
    toggleFAQ: toggleFAQ,
    activeIndex: activeIndex
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "24px",
      fontSize: "16px",
      fontWeight: "700",
      display: "flex"
    }
  }, posts === null || posts === void 0 || (_posts$fields2 = posts.fields) === null || _posts$fields2 === void 0 ? void 0 : _posts$fields2.pageFooterText, "\xA0\xA0\xA0", /*#__PURE__*/React.createElement("div", {
    onClick: () => window.open("https://www.bengaluruairport.com/travellers/contact-us", "_blank"),
    style: {
      color: "#04ADAA",
      textDecoration: "none"
    }
  }, posts === null || posts === void 0 || (_posts$fields3 = posts.fields) === null || _posts$fields3 === void 0 ? void 0 : _posts$fields3.pageFooterConatctUs)));
};
const Login = _ref3 => {
  var _posts$fields4, _posts$fields5, _posts$fields6, _posts$fields7, _posts$fields8, _posts$fields9, _posts$fields10, _posts$fields11, _posts$fields12, _posts$fields13, _posts$fields14, _posts$fields15, _posts$fields16, _posts$fields17, _posts$fields18, _posts$fields19, _posts$fields20, _posts$fields21, _posts$fields22, _posts$fields23, _posts$fields24, _posts$fields25, _posts$fields26, _posts$fields27, _posts$fields28, _posts$fields29, _posts$fields30, _posts$fields31, _posts$fields32, _posts$fields33;
  let {
    navigate,
    onSignIn
  } = _ref3;
  const [posts, setPosts] = useState([]);
  const [faqs, setFaqs] = useState([]);
  function pageTitleFunc(pageTitle) {
    if (pageTitle != undefined) {
      const pageTitleVar = pageTitle.replace(/\*\*(.*?)\*\*/, "&nbsp;<p>$1</p>&nbsp;");
      return pageTitleVar;
    }
  }
  function cardTextZoomFunc(pageTitle) {
    if (pageTitle != undefined) {
      const pageTitleVar = pageTitle.replace(/\*\*(.*?)\*\*/, '&nbsp;<p style="font-size: 30px; margin-bottom: 6px; font-weight: 700;">$1</p>&nbsp;');
      return pageTitleVar;
    }
  }
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    scrollToTop();
  }, []);
  useEffect(() => {
    const fetchPostById = async () => {
      try {
        const entry = await client.getEntry("QUeDnQWrrpfL2Rg3LH7Eq");
        const resolveLinks = async fields => {
          const resolvedFields = {
            ...fields
          };
          for (const key in fields) {
            const field = fields[key];
            if (Array.isArray(field)) {
              resolvedFields[key] = await Promise.all(field.map(async item => {
                if (item.sys && item.sys.type === "Link") {
                  return await client.getAsset(item.sys.id);
                }
                return item;
              }));
            } else if (field.sys && field.sys.type === "Link") {
              if (field.sys.linkType === "Asset") {
                resolvedFields[key] = await client.getAsset(field.sys.id);
              } else if (field.sys.linkType === "Entry") {
                resolvedFields[key] = await client.getEntry(field.sys.id);
              }
            }
          }
          return resolvedFields;
        };
        const resolvedFields = await resolveLinks(entry.fields);
        setPosts({
          ...entry,
          fields: resolvedFields
        });
        setFaqs(resolvedFields.pageFaqItems.map(item => ({
          question: item.fields.faqTitle,
          answer: item.fields.faqDescription
        })));
      } catch (error) {
        console.error("Error fetching the post:", error);
      }
    };
    fetchPostById();
  }, []);
  //   useEffect(() => {
  //     if (posts) {
  //         console.log('Login:', posts);
  //     }
  //   }, [posts]);
  const settings1 = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    adaptiveHeight: true,
    centerMode: true,
    variableWidth: true,
    arrows: false,
    swipeToSlide: true,
    // Allows swiping to any slide
    touchThreshold: 10,
    responsive: [{
      breakpoint: 1124,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 650,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "landing-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-1",
    style: {
      backgroundImage: "url(".concat(posts === null || posts === void 0 || (_posts$fields4 = posts.fields) === null || _posts$fields4 === void 0 || (_posts$fields4 = _posts$fields4.cardBackgroundImage) === null || _posts$fields4 === void 0 || (_posts$fields4 = _posts$fields4.fields) === null || _posts$fields4 === void 0 || (_posts$fields4 = _posts$fields4.file) === null || _posts$fields4 === void 0 ? void 0 : _posts$fields4.url, ")"),
      height: "319px",
      borderRadius: "0 0 20px 20px",
      boxShadow: "0px 5px 20px 5px #101919",
      backgroundRepeat: "no-repeat",
      backgroundSize: "100% 100%"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading"
  }, /*#__PURE__*/React.createElement("img", {
    className: "blr-pulse-logo",
    src: posts === null || posts === void 0 || (_posts$fields5 = posts.fields) === null || _posts$fields5 === void 0 || (_posts$fields5 = _posts$fields5.brandLogo) === null || _posts$fields5 === void 0 || (_posts$fields5 = _posts$fields5.fields) === null || _posts$fields5 === void 0 || (_posts$fields5 = _posts$fields5.file) === null || _posts$fields5 === void 0 ? void 0 : _posts$fields5.url,
    alt: "",
    style: {
      marginTop: "30px",
      marginBottom: "8px"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      color: "#F1CB84",
      fontSize: "14px",
      fontWeight: "600",
      letterSpacing: "1.4px"
    }
  }, posts === null || posts === void 0 || (_posts$fields6 = posts.fields) === null || _posts$fields6 === void 0 ? void 0 : _posts$fields6.cardText1), /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: "center",
      color: "#F1CB84",
      fontSize: "36px",
      fontWeight: "800",
      lineHeight: "42px",
      marginTop: "32px",
      background: "linear-gradient(274.19deg, #EBBD67 15.62%, #FFEAC3 46.63%, #E1B667 87.79%)",
      WebkitBackgroundClip: "text",
      color: "transparent",
      backgroundClip: "text"
    }
  }, posts === null || posts === void 0 || (_posts$fields7 = posts.fields) === null || _posts$fields7 === void 0 ? void 0 : _posts$fields7.cardText2), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "27px",
      height: "56px",
      display: "flex",
      alignItems: "flex-end",
      background: "#FFD288",
      borderRadius: "27px"
    }
  }, /*#__PURE__*/React.createElement("button", {
    style: {
      display: "flex",
      width: "342px",
      padding: "15px 20px",
      justifyContent: "center",
      alignItems: "center",
      gap: "10px",
      fontSize: "16px",
      fontWeight: "800",
      borderRadius: "100px",
      border: "0px",
      background: "linear-gradient(270deg, #D6A244 0%, #FFEBC6 48.28%, #E5B04C 100%)",
      color: "var(--Black, #273135)"
    },
    onClick: onSignIn
  }, posts === null || posts === void 0 || (_posts$fields8 = posts.fields) === null || _posts$fields8 === void 0 ? void 0 : _posts$fields8.cardCtaText)))), posts !== null && posts !== void 0 && (_posts$fields9 = posts.fields) !== null && _posts$fields9 !== void 0 && _posts$fields9.toggle1 ? /*#__PURE__*/React.createElement("div", {
    className: "container-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading",
    dangerouslySetInnerHTML: {
      __html: pageTitleFunc(posts === null || posts === void 0 || (_posts$fields10 = posts.fields) === null || _posts$fields10 === void 0 ? void 0 : _posts$fields10.pageTitle1)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "carousel-container"
  }, /*#__PURE__*/React.createElement(Carousel, {
    "data-bs-theme": "dark",
    controls: false,
    touch: true
  }, posts === null || posts === void 0 || (_posts$fields11 = posts.fields) === null || _posts$fields11 === void 0 || (_posts$fields11 = _posts$fields11.pageContent1) === null || _posts$fields11 === void 0 ? void 0 : _posts$fields11.map((item, index) => /*#__PURE__*/React.createElement(Carousel.Item, {
    key: index
  }, /*#__PURE__*/React.createElement("img", {
    className: "d-block w-100",
    src: item.fields.cardBackgroundImage.fields.file.url,
    alt: item.fields.cardBackgroundImage.fields.file.filename
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      top: "72.56px",
      left: "0",
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      color: "white"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      color: "#F1CB84",
      fontSize: "22px",
      fontWeight: "600",
      lineHeight: "normal"
    }
  }, item.fields.cardText1), /*#__PURE__*/React.createElement("div", {
    style: {
      color: "#FFF",
      fontSize: "13px",
      fontWeight: "400",
      lineHeight: "normal"
    }
  }, /*#__PURE__*/React.createElement(ReactMarkdown, {
    rehypePlugins: [rehypeRaw],
    remarkPlugins: [remarkGfm]
  }, item.fields.cardText2)), /*#__PURE__*/React.createElement("div", {
    style: {
      color: "#FFF",
      fontSize: "22px",
      fontWeight: "600",
      lineHeight: "normal",
      display: "flex",
      alignItems: "center"
    },
    dangerouslySetInnerHTML: {
      __html: cardTextZoomFunc(item.fields.cardText3)
    }
  }))))))) : /*#__PURE__*/React.createElement(React.Fragment, null), posts !== null && posts !== void 0 && (_posts$fields12 = posts.fields) !== null && _posts$fields12 !== void 0 && _posts$fields12.toggle2 ? /*#__PURE__*/React.createElement("div", {
    className: "container-6",
    style: {
      marginTop: "18px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading",
    dangerouslySetInnerHTML: {
      __html: pageTitleFunc(posts === null || posts === void 0 || (_posts$fields13 = posts.fields) === null || _posts$fields13 === void 0 ? void 0 : _posts$fields13.pageTitle2)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "slider-container",
    style: {
      height: "380px",
      margin: "15px 0px 30px"
    }
  }, /*#__PURE__*/React.createElement(Slider, settings1, posts === null || posts === void 0 || (_posts$fields14 = posts.fields) === null || _posts$fields14 === void 0 || (_posts$fields14 = _posts$fields14.pageContent2) === null || _posts$fields14 === void 0 ? void 0 : _posts$fields14.map((item, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "slide"
  }, /*#__PURE__*/React.createElement("img", {
    style: {
      textAlign: "center"
    },
    src: item.fields.cardBackgroundImage.fields.file.url,
    alt: item.fields.cardBackgroundImage.fields.file.filename
  })))))) : /*#__PURE__*/React.createElement(React.Fragment, null), posts !== null && posts !== void 0 && (_posts$fields15 = posts.fields) !== null && _posts$fields15 !== void 0 && _posts$fields15.toggle3 ? /*#__PURE__*/React.createElement("div", {
    className: "container-5",
    style: {
      paddingTop: "0px",
      backgroundColor: "transparent",
      height: "315px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading",
    dangerouslySetInnerHTML: {
      __html: pageTitleFunc(posts === null || posts === void 0 || (_posts$fields16 = posts.fields) === null || _posts$fields16 === void 0 ? void 0 : _posts$fields16.pageTitle3)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "carousel-container"
  }, /*#__PURE__*/React.createElement(Carousel, {
    "data-bs-theme": "dark",
    controls: false,
    touch: true
  }, posts === null || posts === void 0 || (_posts$fields17 = posts.fields) === null || _posts$fields17 === void 0 || (_posts$fields17 = _posts$fields17.pageContent3) === null || _posts$fields17 === void 0 ? void 0 : _posts$fields17.map((item, index) => /*#__PURE__*/React.createElement(Carousel.Item, {
    key: index
  }, /*#__PURE__*/React.createElement("img", {
    className: "d-block w-100",
    src: item.fields.cardBackgroundImage.fields.file.url,
    alt: item.fields.cardBackgroundImage.fields.file.filename
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      top: "25px",
      left: "64px",
      width: "100%",
      height: "100%",
      color: "white"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      color: "#FFF",
      fontSize: "22px",
      fontWeight: "600",
      lineHeight: "normal"
    }
  }, item.fields.cardText1), /*#__PURE__*/React.createElement("div", {
    style: {
      color: "#FFF",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "normal",
      width: "240.754px"
    }
  }, /*#__PURE__*/React.createElement(ReactMarkdown, {
    rehypePlugins: [rehypeRaw],
    remarkPlugins: [remarkGfm]
  }, item.fields.cardText2)), /*#__PURE__*/React.createElement("div", {
    className: "invite"
  }, /*#__PURE__*/React.createElement("button", null, item.fields.cardText3)))))))) : /*#__PURE__*/React.createElement(React.Fragment, null), posts !== null && posts !== void 0 && (_posts$fields18 = posts.fields) !== null && _posts$fields18 !== void 0 && _posts$fields18.toggle4 ? /*#__PURE__*/React.createElement("div", {
    className: "container-3",
    style: {
      backgroundImage: "url(".concat(posts === null || posts === void 0 || (_posts$fields19 = posts.fields) === null || _posts$fields19 === void 0 || (_posts$fields19 = _posts$fields19.pageContent4[0]) === null || _posts$fields19 === void 0 || (_posts$fields19 = _posts$fields19.fields) === null || _posts$fields19 === void 0 || (_posts$fields19 = _posts$fields19.cardBackgroundImage) === null || _posts$fields19 === void 0 || (_posts$fields19 = _posts$fields19.fields) === null || _posts$fields19 === void 0 || (_posts$fields19 = _posts$fields19.file) === null || _posts$fields19 === void 0 ? void 0 : _posts$fields19.url, ")"),
      backgroundSize: "100%",
      height: "235px",
      margin: "5px 0 6px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "earn-points-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "earn"
  }, posts === null || posts === void 0 || (_posts$fields20 = posts.fields) === null || _posts$fields20 === void 0 || (_posts$fields20 = _posts$fields20.pageContent4[0]) === null || _posts$fields20 === void 0 || (_posts$fields20 = _posts$fields20.fields) === null || _posts$fields20 === void 0 ? void 0 : _posts$fields20.cardText1), /*#__PURE__*/React.createElement("div", {
    className: "points-quantity"
  }, /*#__PURE__*/React.createElement(ReactMarkdown, {
    rehypePlugins: [rehypeRaw],
    remarkPlugins: [remarkGfm]
  }, posts === null || posts === void 0 || (_posts$fields21 = posts.fields) === null || _posts$fields21 === void 0 || (_posts$fields21 = _posts$fields21.pageContent4[0]) === null || _posts$fields21 === void 0 || (_posts$fields21 = _posts$fields21.fields) === null || _posts$fields21 === void 0 ? void 0 : _posts$fields21.cardText2)), /*#__PURE__*/React.createElement("div", {
    className: "transition"
  }, /*#__PURE__*/React.createElement("img", {
    className: "coin",
    src: "https://d3hc1c528irei0.cloudfront.net/ui/PulseCoin.png",
    alt: ""
  }), " ", posts === null || posts === void 0 || (_posts$fields22 = posts.fields) === null || _posts$fields22 === void 0 || (_posts$fields22 = _posts$fields22.pageContent4[0]) === null || _posts$fields22 === void 0 || (_posts$fields22 = _posts$fields22.fields) === null || _posts$fields22 === void 0 ? void 0 : _posts$fields22.cardText3))) : /*#__PURE__*/React.createElement(React.Fragment, null), posts !== null && posts !== void 0 && (_posts$fields23 = posts.fields) !== null && _posts$fields23 !== void 0 && _posts$fields23.toggle5 ? /*#__PURE__*/React.createElement("div", {
    className: "container-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading",
    dangerouslySetInnerHTML: {
      __html: pageTitleFunc(posts === null || posts === void 0 || (_posts$fields24 = posts.fields) === null || _posts$fields24 === void 0 ? void 0 : _posts$fields24.pageTitle5)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "carousel-container"
  }, /*#__PURE__*/React.createElement(Carousel, {
    "data-bs-theme": "dark",
    controls: false,
    touch: true
  }, posts === null || posts === void 0 || (_posts$fields25 = posts.fields) === null || _posts$fields25 === void 0 || (_posts$fields25 = _posts$fields25.pageContent5) === null || _posts$fields25 === void 0 ? void 0 : _posts$fields25.map((item, index) => /*#__PURE__*/React.createElement(Carousel.Item, {
    key: index
  }, /*#__PURE__*/React.createElement("img", {
    className: "d-block w-100",
    src: item.fields.cardBackgroundImage.fields.file.url,
    alt: item.fields.cardBackgroundImage.fields.file.filename
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      top: "72.56px",
      left: "0",
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      color: "white"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      color: "#F1CB84",
      fontSize: "22px",
      fontWeight: "600",
      lineHeight: "normal"
    }
  }, item.fields.cardText1), /*#__PURE__*/React.createElement("div", {
    style: {
      color: "#FFF",
      fontSize: "13px",
      fontWeight: "400",
      lineHeight: "normal"
    }
  }, /*#__PURE__*/React.createElement(ReactMarkdown, {
    rehypePlugins: [rehypeRaw],
    remarkPlugins: [remarkGfm]
  }, item.fields.cardText2)), /*#__PURE__*/React.createElement("div", {
    style: {
      color: "#FFF",
      fontSize: "22px",
      fontWeight: "600",
      lineHeight: "normal",
      display: "flex",
      alignItems: "center"
    },
    dangerouslySetInnerHTML: {
      __html: cardTextZoomFunc(item.fields.cardText3)
    }
  }))))))) : /*#__PURE__*/React.createElement(React.Fragment, null), posts !== null && posts !== void 0 && (_posts$fields26 = posts.fields) !== null && _posts$fields26 !== void 0 && _posts$fields26.toggle6 ? /*#__PURE__*/React.createElement("div", {
    className: "container-7",
    style: {
      backgroundImage: "url(".concat(posts === null || posts === void 0 || (_posts$fields27 = posts.fields) === null || _posts$fields27 === void 0 || (_posts$fields27 = _posts$fields27.pageContent6[0]) === null || _posts$fields27 === void 0 || (_posts$fields27 = _posts$fields27.fields) === null || _posts$fields27 === void 0 || (_posts$fields27 = _posts$fields27.cardBackgroundImage) === null || _posts$fields27 === void 0 || (_posts$fields27 = _posts$fields27.fields) === null || _posts$fields27 === void 0 || (_posts$fields27 = _posts$fields27.file) === null || _posts$fields27 === void 0 ? void 0 : _posts$fields27.url, ")"),
      backgroundSize: "100%",
      height: "255px",
      margin: "5px 0 6px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "refer-earn-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "banner",
    dangerouslySetInnerHTML: {
      __html: pageTitleFunc(posts === null || posts === void 0 || (_posts$fields28 = posts.fields) === null || _posts$fields28 === void 0 || (_posts$fields28 = _posts$fields28.pageContent6[0]) === null || _posts$fields28 === void 0 || (_posts$fields28 = _posts$fields28.fields) === null || _posts$fields28 === void 0 ? void 0 : _posts$fields28.cardText1)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "details"
  }, /*#__PURE__*/React.createElement(ReactMarkdown, {
    rehypePlugins: [rehypeRaw],
    remarkPlugins: [remarkGfm]
  }, posts === null || posts === void 0 || (_posts$fields29 = posts.fields) === null || _posts$fields29 === void 0 || (_posts$fields29 = _posts$fields29.pageContent6[0]) === null || _posts$fields29 === void 0 || (_posts$fields29 = _posts$fields29.fields) === null || _posts$fields29 === void 0 ? void 0 : _posts$fields29.cardText2)), /*#__PURE__*/React.createElement("div", {
    className: "invite"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onSignIn
  }, /*#__PURE__*/React.createElement("div", null, posts === null || posts === void 0 || (_posts$fields30 = posts.fields) === null || _posts$fields30 === void 0 || (_posts$fields30 = _posts$fields30.pageContent6[0]) === null || _posts$fields30 === void 0 || (_posts$fields30 = _posts$fields30.fields) === null || _posts$fields30 === void 0 ? void 0 : _posts$fields30.cardText3))))) : /*#__PURE__*/React.createElement(React.Fragment, null), posts !== null && posts !== void 0 && (_posts$fields31 = posts.fields) !== null && _posts$fields31 !== void 0 && _posts$fields31.toggle7 ? /*#__PURE__*/React.createElement("div", {
    className: "container-9",
    style: {
      backgroundColor: "transparent"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading",
    dangerouslySetInnerHTML: {
      __html: pageTitleFunc(posts === null || posts === void 0 || (_posts$fields32 = posts.fields) === null || _posts$fields32 === void 0 ? void 0 : _posts$fields32.pageTitle7)
    }
  }), /*#__PURE__*/React.createElement("img", {
    className: "",
    src: posts === null || posts === void 0 || (_posts$fields33 = posts.fields) === null || _posts$fields33 === void 0 || (_posts$fields33 = _posts$fields33.pageContent7[0]) === null || _posts$fields33 === void 0 || (_posts$fields33 = _posts$fields33.fields) === null || _posts$fields33 === void 0 || (_posts$fields33 = _posts$fields33.cardBackgroundImage) === null || _posts$fields33 === void 0 || (_posts$fields33 = _posts$fields33.fields) === null || _posts$fields33 === void 0 || (_posts$fields33 = _posts$fields33.file) === null || _posts$fields33 === void 0 ? void 0 : _posts$fields33.url,
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: "invite",
    style: {
      margin: "25px auto",
      justifyContent: "center",
      width: "117px"
    }
  }, /*#__PURE__*/React.createElement("button", {
    style: {
      width: "111px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    onClick: () => navigate("/sponsorlist")
  }, "View All")))) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(FAQList, {
    faqs: faqs,
    posts: posts,
    navigate: navigate
  }));
};
export { Login };